module.exports = __webpack_public_path__ + "img/14.919f74cd.png";